import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Notifications from "../helpers/toast-notifications";
import i18n from "../i18n";
import tablesStore from "./tablesStore";
import mainViewsStore from "./modules/mainViews/mainViewsStore";
import buffetMainViewStore from "./modules/buffet/buffetMainViewStore";
import gradeEduclassShared from "./modules/mainViews/grade-educationClass-shared/store";
import studentStore from "./modules/students/studentStore";
import parents from "./modules/users/parents";
import admins from "./modules/users/admins";
import teachersStore from "./modules/teachers/teachersStore";
import cashierFinancialOrder from "./modules/financial-order/cashierFinancialOrder";
import accountantFinancialOrder from "./modules/financial-order/accountantFinancialOrder";
import costCenter from "./modules/costCenter";
import cashierBox from "./modules/cashierBox";
import router from "../router";
import timeAttendance from "@/store/modules/HR/time_attendence";
import employees from "@/store/modules/HR/employees";
import calculations from "@/store/modules/HR/calculations";
import loans from "@/store/modules/HR/loans";
import payments from "@/store/modules/HR/payments";
import vacations from "@/store/modules/HR/vacations";
import variations from "@/store/modules/HR/variations";
import payinstallment from "@/store/modules/pay-installments/payinstallment";
import restrictions from "@/store/modules/restrictions";

Vue.use(Vuex);
// online serveer domain
// https://bahlol-demo-back.point-dev.net
// https://bahlol-back.point-dev.net/api
// https://bahlol-back.incentive-dev.com
// https://incentive-dev.com
// http://192.168.100.2:8080
// https://back-demo.incentive-dev.com
// http://127.0.0.1:8080
// https://platform-back.incentive-dev.com/

export default new Vuex.Store({
  state: {
    serverDomain: "https://platform-back.incentive-dev.com/api",
    barImage: "",
    drawer: false,
    userData: {
      username: "",
      abilities: [],
    },
    theme: null,
    routeNameAddition: "",
    isDarkMode: false,
    drawerList: null,
    sectionTitle: null,
    schoolInfo: null,
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_SECTION_TITLE(state, payload) {
      state.sectionTitle = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_DRAWER_LIST(state, payload) {
      state.drawerList = payload;
    },
    setUserData(state, userInfo) {
      state.userData.username = userInfo.user_name;
      state.userData.abilities = userInfo.ability;
    },
    setSchoolTheme(state, schoolTheme) {
      state.theme = schoolTheme;
    },
    setRouteNameAddition(state, addition) {
      state.routeNameAddition = addition;
    },
    SET_DARK_MODE(state, payload) {
      state.isDarkMode = payload;
    },
  },
  actions: {
    async userLogin({ commit }, userData) {
      try {
        // axios.defaults.headers.common["term"] = userData.termId;
        // localStorage.setItem("school_term", userData.termId);
        const logInResponse = await axios.post("/auth/login", {
          username: userData.username,
          password: userData.password,
          theme: userData.theme,
        });

        console.log("login response", logInResponse);
        commit("setUserData", logInResponse.data.data);
        localStorage.setItem(
          "school_user_data",
          JSON.stringify(logInResponse.data.data)
        );
        localStorage.setItem("school_term", logInResponse.data.data.term);
        axios.defaults.headers.common["term"] = logInResponse.data.data.term;
        localStorage.setItem(
          "school_access_token",
          logInResponse.data.data.access_token
        );
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + logInResponse.data.data.access_token;
        Notifications(
          i18n.t("login success"),
          { timeout: 1000, rtl: true },
          "success"
        );  
        localStorage.setItem("school_theme",JSON.stringify(logInResponse.data.data.theme));
        if(logInResponse.data.data.theme){
          commit("setSchoolTheme", logInResponse.data.data.theme.theme);
        }
        router.replace("/");
      } catch (err) {
      } finally {
      }
    },
    autoLogIn({ commit }) {
      commit(
        "setUserData",
        JSON.parse(localStorage.getItem("school_user_data"))
      );
      commit("setSchoolTheme",  JSON.parse(localStorage.getItem("school_theme")));
      axios.defaults.headers.common["term"] =
        localStorage.getItem("school_term");
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("school_access_token");
    },
  },
  getters: {
    getUserName(state) {
      return state.userData.username;
    },
    getUserAbilities(state) {
      return state.userData.abilities;
    },
    getRouteNameAddition(state) {
      return state.routeNameAddition;
    },
  },
  modules: {
    tablesStore,
    ...mainViewsStore,
    ...buffetMainViewStore,
    ...studentStore,
    ...teachersStore,
    ...gradeEduclassShared,
    costCenter,
    cashierBox,
    parents,
    admins,
    cashierFinancialOrder,
    accountantFinancialOrder,
    timeAttendance,
    employees,
    calculations,
    loans,
    payments,
    vacations,
    variations,
    payinstallment,
    restrictions,
  },
});
